import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/custom-bootstrap.scss';
import './styles/design-system/admin-tokens.css';
import './styles/design-system/admin-primitives.css';
import './styles/design-system/admin-motion.css';
import './components/ui/ui.css';
import './styles/ecommerce-products.css';
import './styles/invisible-scroll.css';
import { loadProductFocus } from './config/productFocus';
import { AuthProvider } from './contexts/AuthContext';
import { AlertProvider } from './contexts/AlertContext';
import App from './App';

void loadProductFocus(process.env.REACT_APP_API_URL || 'http://localhost:3333');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
      <AuthProvider>
        <AlertProvider>
          <App />
        </AlertProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
